export enum EditorType {
	HTML = 'HTML',
	INDESIGN = 'INDESIGN',
}

export enum EditableType {
	text = 'text',
	image = 'image',
	video = 'video',
	animation = 'animation',
	iframe = 'iframe',
	link = 'link',
	themes = 'themes',
	slider = 'slider',
}

export enum LinkType {
	url = 'url',
	mailto = 'mailto',
	goToPage = 'goToPage',
	popup = 'popup',
	unsupported = 'unsupported',
}

export enum ActionEventType {
	goToPage = 'goToPage',
	popup = 'popup',
	mailto = 'mailto',
	unsupported = 'unsupported',
}

export enum LinkParam {
	email = 'email',
	page = 'page',
	param = 'param',
}

export const LinksMap = {
	[LinkType.mailto]: LinkParam.email,
	[LinkType.goToPage]: LinkParam.page,
};

export enum PdfImportingStatus {
	IMPORTING = 'IMPORTING',
	PROCESSING = 'PROCESSING',
	REMOVING = 'REMOVING',
}

export enum ZoomType {
	OUT = 'OUT',
	IN = 'IN',
	FIT = 'FIT',
}

export enum ShowAloneSide {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}

export enum VerticalAlignClassName {
	// TOP is not needed because no className is set for this value in inDesign
	CENTER = 'vertical-align-center',
	BOTTOM = 'vertical-align-bottom',
}

export const colorMarkClassName = 'rte-font-color';
export const linkClassName = 'rte-underline';
export const subScriptClassName = 'rte-subscript';
export const superScriptClassName = 'rte-superscript';
export const editedElementClassName = 'edited';
export const emptyTextFieldClassName = 'is-empty';

export const IGNORE_PAGE_CLICK_CLASSNAME = 'ignore-page-click';
export const EDIT_PANEL_CLASSNAME = 'edit-panel';
export const SPREAD_BACKGROUND_CLICK_CLASSNAME = 'spread-background-click';
export const SETTINGS_PANEL_CLASSNAME = 'settings-panel';
export const PAGE_CONTENT_CLASSNAME = 'page-content';

export enum EditorMessageTypes {
	RELOAD_PUBLICATION_SETTINGS = 'reloadPublicationSettings',
	NEW_PLAYLIST_ID = 'newPlaylistId',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/constants.ts